
<div class="text-right mt-n2"><small class="font-italic">
    {{ 'administration_characterCounter_label' | translate : {TotalCount: totalCount, MaxLength: maxLength} }}
</small></div>